import { ExtractProps, withTranslations } from 'hooks/useTranslations'
import { graphql, useStaticQuery } from 'gatsby'

declare global {
  interface Snippets {
    'templates-Cart': {
      your_cart: void
      no_items_text: void
      info_not_logged_in: void
      cart_info_text_below: void
      cart_shop_variety_text: void
      continue_shopping: void
      to_checkout_text: void
      account_signIn: void
      orderdetails_overview: void
      seo_title: void
      isMeterware: void
      channel_info_description_b2b: void
      channel_info_description_b2c: void
      channel_info_proceed: void
      channel_info_remove_items_b2b: void
      channel_info_remove_items_b2c: void
      channel_info_support_text: void
      channel_info_support_link: void
      channel_info_proceed_as_b2b: void
      channel_info_proceed_as_b2c: void
      shipping_by_partner: void
      info_box: void
      installment_payment: {
        PAYPAL: string
      }
    }
  }
}

export default <C extends React.FC<ExtractProps<C>>>(Component: C) =>
  withTranslations(Component, () =>
    useStaticQuery(graphql`
      query templates_Cart_translations {
        your_cart: snippet(group: "templates-Cart", name: "your_cart")
        no_items_text: snippet(group: "templates-Cart", name: "no_items_text")
        info_not_logged_in: snippet(
          group: "templates-Cart"
          name: "info_not_logged_in"
        )
        channel_info_description_b2b: snippet(
          group: "templates-Cart"
          name: "channel_info_description_b2b"
        )
        channel_info_description_b2c: snippet(
          group: "templates-Cart"
          name: "channel_info_description_b2c"
        )
        channel_info_proceed: snippet(
          group: "templates-Cart"
          name: "channel_info_proceed"
        )
        channel_info_remove_items_b2b: snippet(
          group: "templates-Cart"
          name: "channel_info_remove_items_b2b"
        )
        channel_info_remove_items_b2c: snippet(
          group: "templates-Cart"
          name: "channel_info_remove_items_b2c"
        )
        channel_info_support_text: snippet(
          group: "templates-Cart"
          name: "channel_info_support_text"
        )
        channel_info_support_link: snippet(
          group: "templates-Cart"
          name: "channel_info_support_link"
        )
        channel_info_proceed_as_b2b: snippet(
          group: "templates-Cart"
          name: "channel_info_proceed_as_b2b"
        )
        channel_info_proceed_as_b2c: snippet(
          group: "templates-Cart"
          name: "channel_info_proceed_as_b2c"
        )
        cart_info_text_below: snippet(
          group: "templates-Cart"
          name: "cart_info_text_below"
        )
        cart_shop_variety_text: snippet(
          group: "templates-Cart"
          name: "cart_shop_variety_text"
        )
        continue_shopping: snippet(
          group: "templates-Cart"
          name: "continue_shopping"
        )
        to_checkout_text: snippet(
          group: "templates-Cart"
          name: "to_checkout_text"
        )
        account_signIn: snippet(group: "templates-Cart", name: "account_signIn")
        orderdetails_overview: snippet(
          group: "templates-Cart"
          name: "orderdetails_overview"
        )
        seo_title: snippet(group: "templates-Cart", name: "seo_title")
        available_meterware: snippet(
          group: "deliveryInfo"
          name: "available_meterware"
        )
        shipping_by_partner: snippet(
          group: "templates-Cart"
          name: "shipping_by_partner"
        )
        info_box: snippet(group: "templates-Cart", name: "info_box")
        installment_payment: snippet(
          group: "templates-Cart"
          name: "installment_payment"
        )
      }
    `)
  )
